/* Progressive desktop hover; native click, touch and keyboard remain available. */
(() => {
  if (window.songaraNavigationV2) return;
  window.songaraNavigationV2 = true;
  const bound = new WeakSet();
  const media = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  function init(root = document) {
    root.querySelectorAll('.songara-navigation[data-songara-hover="true"]').forEach(nav => {
      if (bound.has(nav)) return;
      bound.add(nav);
      const menus = [...nav.querySelectorAll('details.songara-mega')];
      menus.forEach(details => {
        const summary = details.querySelector(':scope > summary');
        let timer;
        const close = () => {
          const disclosure = details.closest('header-menu');
          if (typeof disclosure?.close === 'function') disclosure.close();
          else { details.removeAttribute('open'); summary.setAttribute('aria-expanded', 'false'); }
        };
        details.addEventListener('pointerenter', event => {
          if (!media.matches || event.pointerType === 'touch') return;
          clearTimeout(timer);
          timer = setTimeout(() => {
            menus.forEach(other => {
              if (other !== details && other.open) {
                other.closest('header-menu')?.close();
              }
            });
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          }, 100);
        });
        details.addEventListener('pointerleave', () => {
          clearTimeout(timer);
          if (!media.matches) return;
          timer = setTimeout(() => {
            if (!details.contains(document.activeElement)) close();
          }, 220);
        });
        details.addEventListener('focusin', () => clearTimeout(timer));
        details.addEventListener('keydown', event => {
          if (event.key === 'Escape') clearTimeout(timer);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
